import { render, staticRenderFns } from "./WaiterMenu.vue?vue&type=template&id=3174561a&scoped=true&"
import script from "./WaiterMenu.vue?vue&type=script&lang=js&"
export * from "./WaiterMenu.vue?vue&type=script&lang=js&"
import style0 from "./WaiterMenu.vue?vue&type=style&index=0&id=3174561a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3174561a",
  null
  
)

export default component.exports